/**
* @file 业务设置-选座模板
* */
<template>
  <div id="seat">
    <el-form :model="form" :rules="rules" ref="form" label-width="114px">
      <div class="head">
        <p>
          <span class="dian">·</span>
          班次添加车辆时，将根据所选车型自动应用座位价格
        </p>
      </div>

      <div v-for="item in form.vehicleSeatConfigVo" :key="item.vehicleSeat">
        <div class="titl" style="margin: 20px 0 20px 0">
          <span> {{ item.vehicleSeat }}座 </span>
          <el-button v-if="item.vehicleSeat == 5" @click="save" type="primary">保存</el-button>
        </div>

        <div class="cont">
          <div class="cont-left">
            <div class="drivers">
              <div class="driver"></div>
              司机
            </div>

            <div :class="
              item.vehicleSeat == 5
                ? 'passe1'
                : item.vehicleSeat == 7
                  ? 'passe2'
                  : item.vehicleSeat == 8
                    ? 'passe3'
                    : item.vehicleSeat == 9
                      ? 'passe4'
                      : ''
            " v-for="(seat, index) in item.seatNoAndFeeVos" :key="index">
              <div class="passenger"></div>
              <p>
                {{ seat.seatNo }}
              </p>
            </div>
          </div>

          <div class="cont-right">
            <div v-for="(seat, index) in item.seatNoAndFeeVos" :key="index">
              <span class="driver-number">{{ seat.seatNo }}</span>
              <el-input type="text" v-model="seat.fee" placeholder="请设置座位价格" @input="search($event)" minlength="1"
                maxlength="3" oninput="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'0')">
                <p class="input-suffix" slot="suffix">元</p>
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "seat",
  data() {
    return {
      // 表单
      form: {
        vehicleSeatConfigVo: [],
      },
      // 校验规则
      rules: {},
      // 保存按钮loading
      loading: false,
    };
  },
  methods: {
    async save() {
      let b = /^\d+(\.\d{1,2})?$/;
      this.form.vehicleSeatConfigVo.forEach((item) => {
        //
        item.seatNoAndFeeVos.forEach((i) => {
          //
          // if (i.fee == 0) {
          //   i.fee = null;
          // }
          let c = i.fee;
          b.test(c);
          i.fee = c;
        });
      });
      let url = "/api/v1/manage/systems/vehicleSeatConfig";
      let params = this.$utils.deepCopyFn(this.form);
      params.vehicleSeatConfigVo = JSON.stringify(params.vehicleSeatConfigVo);
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功");
        // history.go(0)
        this.getConfig();
      }
    },
    async getConfig() {
      let url = "/api/v1/manage/systems/vehicleSeatConfig";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.form.vehicleSeatConfigVo = data.data;
      }
    },
  },
  created() {
    this.getConfig();
  },
  filters: {},
};
</script>

<style lang="less">
#seat {

  .el-input__inner,
  .el-input {
    width: 200px;
  }

  .cont {
    display: flex;
    margin-top: 32px;

    .cont-left {
      display: flex;
      flex-wrap: wrap;
      width: 300px;

      .drivers {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin-left: 60px;
      }

      .passe1 {
        >p {
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }

        &:nth-child(2) {
          margin-left: 60px;
          margin-right: 60px;
        }

        &:nth-child(3) {
          margin-left: 30px;
        }

        &:nth-child(4) {
          margin-left: 40px;
        }

        &:nth-child(5) {
          margin-left: 40px;
        }
      }

      .passe2 {
        >p {
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }

        &:nth-child(2) {
          margin-left: 60px;
          margin-right: 60px;
        }

        &:nth-child(3) {
          margin-left: 60px;
        }

        &:nth-child(4) {
          margin-left: 60px;
          margin-right: 60px;
        }

        &:nth-child(5) {
          margin-left: 30px;
        }

        &:nth-child(6) {
          margin-left: 40px;
        }

        &:nth-child(7) {
          margin-left: 40px;
        }
      }

      .passe3 {
        >p {
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }

        &:nth-child(2) {
          margin-left: 60px;
          margin-right: 60px;
        }

        &:nth-child(3) {
          margin-left: 30px;
        }

        &:nth-child(4) {
          margin-left: 40px;
        }

        &:nth-child(5) {
          margin-left: 40px;
          margin-right: 40px;
        }

        &:nth-child(6) {
          margin-left: 30px;
        }

        &:nth-child(7) {
          margin-left: 40px;
        }

        &:nth-child(8) {
          margin-left: 40px;
        }
      }

      .passe4 {
        >p {
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }

        &:nth-child(2) {
          margin-left: 60px;
          margin-right: 60px;
        }

        &:nth-child(3) {
          margin-left: 60px;
        }

        &:nth-child(4) {
          margin-left: 60px;
          margin-right: 60px;
        }

        &:nth-child(5) {
          margin-left: 60px;
        }

        &:nth-child(6) {
          margin-left: 60px;
          margin-right: 60px;
        }

        &:nth-child(7) {
          margin-left: 30px;
        }

        &:nth-child(8) {
          margin-left: 40px;
        }

        &:nth-child(9) {
          margin-left: 40px;
        }
      }

      .driver {
        width: 40px;
        height: 40px;
        background: #ccc;
        background: url("../../../assets/img/zuowei2.png");
      }

      .passenger {
        width: 40px;
        height: 40px;
        background: url("../../../assets/img/zuowei1.png") 100% 100%;
      }
    }

    .cont-right {
      margin-left: 20px;

      .driver-number {
        display: inline-block;
        color: #333333;
        width: 36px;
        font-size: 16px;
        font-weight: 600;
        line-height: 21px;
      }

      .input-suffix {
        font-size: 13px;
        font-weight: bold;
        line-height: 28px;
        color: #333333;
        padding: 0 6px 0 0;
      }

      >div {
        margin-bottom: 16px;
      }
    }
  }

  .head {
    display: flex;

    p {
      line-height: 28px;
      display: flex;
      align-items: center;
      color: #999999;
    }
  }

  .titl {
    border-left: 5px solid #409efc;
    color: #333333;
    width: 550px;
    height: 20px;
    font-size: 20px;
    font-weight: 600;
    line-height: 1;
    color: #333333;
    opacity: 1;
    text-indent: 1rem;
    display: flex;
    justify-content: space-between;
    overflow: inherit;

    .el-button {
      height: 28px !important;
    }
  }

  .dian {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #999999;
    border-radius: 50%;
    opacity: 1;
    margin-right: 6px;
  }
}

// 禁用input的number箭头
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}</style>
